"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["#requestFloatingBtn[_ngcontent-%COMP%]{position:fixed;bottom:20px;right:30px;z-index:99;cursor:pointer;padding:15px;border-radius:10px}#requestFloatingBtn[_ngcontent-%COMP%]:hover{background-color:#555}#bannerimage[_ngcontent-%COMP%]{width:758px;height:140px;background-color:#000;background-position:50%;padding-bottom:30px}.content-space[_ngcontent-%COMP%]{padding-top:10px}"];
exports.styles = styles;
//# sourceMappingURL=seriesinformation.component.scss.shim.ngstyle.js.map